import React, { useState, useEffect } from 'react';
import PermanentDrawerLeft from '../components/Drawer';
import { useLocation } from 'react-router-dom';

const Layout = ({ children }) => {

  const location = useLocation();
  const currentRoute = location.pathname;
  const [isLogoutVisible, setIsLogoutVisible] = useState(false)
  const [isSelected, setIsSelected] = useState(false)


  useEffect(() => {
    if (currentRoute.includes('terminal-details')) {
      setIsSelected('/terminals')
    } else if (currentRoute.includes('safety-details')) {
      setIsSelected('/safety')
    } else if (currentRoute.includes('report-details')) {
      setIsSelected('/reports')
    } else {
      setIsSelected(currentRoute)
    }
  }, [currentRoute])
  return (
    <div className=' overflow-y-hidden h-[100%] '>
      <PermanentDrawerLeft isLogoutVisible={isLogoutVisible} setIsLogoutVisible={setIsLogoutVisible} isSelected={isSelected} />
      {children}
    </div>
  );
};

export default Layout;